import { lazy } from 'react';

import commonModals from 'components/Common/modals';

import uploaderModals from 'components/Common/Uploader/modals';
import dashboardModals from 'components/Dashboard/modals';

import setAsGoalModals from 'containers/SetAsGoal/modals';

import accountabilitySystemAnalyticsModals from 'modules/AccountabilitySystemAnalytics/modals/modals';
import accountabilitySystemSetupModals from 'modules/AccountabilitySystemSetup/modals';
import accountSettingsModals from 'modules/AccountSettings/modals';
import alumniModals from 'modules/Alumni/modals';
import alumniSurveyModals from 'modules/AlumniSurveys/modals';
import assessmentsModals from 'modules/Assessments/modals';
import awardLetterVerificationModals from 'modules/AwardLetterVerification/modals';
import bulkStudentSelectModals from 'modules/BulkStudentSelect/modals';
import collegeAppConfigModals from 'modules/CollegeAppConfig/modals';
import appManagerModals from 'modules/CollegeApplicationManager/modals';
import appManagerModalsV2 from 'modules/CollegeApplicationManager/pages/ApplicationTrackBoard/modals';
import counselorDashboardModals from 'modules/CounselorDashboard/modals';
import meetingSchedulerModals from 'modules/CounselorMeetingScheduler/modals';
import courseCatalogModals from 'modules/CourseCatalog/modals';
import coursePlannerModals from 'modules/CoursePlanner/modals';
import coursePlannerListingModals from 'modules/CoursePlannerListing/modals';
import credentialWalletModals from 'modules/CredentialWallet/modals';
import cteProgramsDashboard from 'modules/CTEProgramsDashboard/K12Admin/modals';
import dataIntegrationModals from 'modules/DataIntegration/modals';
import digitalBadgesModals from 'modules/DigitalBadges/modals';
import districtSettingsModals from 'modules/DistrictSettings/modals';
import documentCenterModals from 'modules/DocumentCenter/modals';
import efillModals from 'modules/EFill/modals';
import elementaryCareersModals from 'modules/ElementaryCareers/modals';
import elementaryCheckinsModals from 'modules/ElementaryCheckins/modals';
import elementaryStudentCasefileModals from 'modules/ElementaryStudentCasefile/modals';
import K12EventSchedulerV2Modals from 'modules/EventSchedulerV2/K12Admin/modals';
import memberEventsModals from 'modules/EventSchedulerV2/Member/modals';
import publicEventSchedulerModals from 'modules/EventSchedulerV2/Public/modals';
import experienceTrackingModals from 'modules/ExperienceTracking/modals';
import fafsaReportingAndTrackingModals from 'modules/FAFSAReportingAndTracking/modals';
import featurePaywallModals from 'modules/FeaturePaywall/modals';
import finalListModals from 'modules/FinalList/modals';
import guidedSetupModals from 'modules/GuidedSetup/modals';
import indicatorVerificationModals from 'modules/IndicatorVerification/modals';
import industryPartnerCRMModals from 'modules/IndustryPartnerCRM/modals';
import ipPlacementsModals from 'modules/IndustryPartnerPlacements/modals';
import ipProgramExplorationModals from 'modules/IndustryPartnerProgramExploration/modals';
import ippmModals from 'modules/IndustryPartnerProgramManagement/modals';
import keyReadinessIndicatorsModals from 'modules/KeyReadinessIndicators/modals';
import lessonLibraryModals from 'modules/LessonLibrary/modals';
import lifeSimulatorModals from 'modules/LifeSimulator/modals';
import memberDashboardModals from 'modules/MemberDashboard/modals';
import memberManagementModals from 'modules/MemberManagement/modals';
import mentorVideosModals from 'modules/MentorVideos/modals';
import opportunitiesModals from 'modules/Opportunities/modals';
import opportunityManagementModals from 'modules/OpportunityManagement/modals';
import orgMentorSetupModals from 'modules/OrgMentorSetup/modals';
import personalizedPlansModals from 'modules/PersonalizedPlans/modals';
import profileManagementModals from 'modules/ProfileManagement/modals';
import publicCourseCatalogModals from 'modules/PublicCourseCatalog/modals';
import recordCenterModals from 'modules/RecordCenter/modals';
import reportCenterModals from 'modules/ReportCenter/modals';
import rosterAndTagManagementModals from 'modules/RosterAndTagManagement/modals';
import schoolProfileModals from 'modules/SchoolProfile/modals';
import schoolSearchModals from 'modules/SchoolSearch/modals';
import seniorSurveyModals from 'modules/SeniorSurvey/modals';
import staffAccountManagementModals from 'modules/StaffAccountManagement/modals';
import staffDashboardModals from 'modules/StaffDashboard/modals';
import staffPersonalizedPlansModals from 'modules/StaffPersonalizedPlans/modals';
import studentCasefileModals from 'modules/StudentCasefile/modals';
import surveyDetailsModals from 'modules/StudentDashboard/modals';
import studentDemoAccountModals from 'modules/StudentDemoAccount/modals';
import studentGoalsModals from 'modules/StudentGoals/modals';
import studentMeetingSchedulerModals from 'modules/StudentMeetingScheduler/modals';
import studentPlanListingModals from 'modules/StudentPlanListing/modals';
import studentProfileModals from 'modules/StudentProfile/modals';
import surveyAnalyticsModals from 'modules/SurveyAnalytics/modals';
import surveyBankModals from 'modules/SurveyBankManagement/modals';
import surveyModals from 'modules/Surveys/modals';
import testScoresModals from 'modules/TestScores/modals';
import wouldYouRatherModals from 'modules/WouldYouRather/modals';

const AlumniContactInfoModal = lazy(
  () => import('./AlumniContactInfoModal/AlumniContactInfoModal'),
);
const BulkMessageModal = lazy(() => import('./BulkMessageModal'));
const BulkPDFDownloadModal = lazy(() => import('./BulkPDFDownloadModal'));
const ChooseContactInfoModal = lazy(
  () => import('./ChooseContactInfoModal/ChooseContactInfoModal'),
);
const ConfirmationModal = lazy(() => import('./ConfirmationModal'));
const CoursePlanListingExportModal = lazy(
  () => import('./CoursePlanListingExportModal'),
);
const DeleteContactConfirmationModal = lazy(
  () =>
    import('./DeleteContactConfirmationModal/DeleteContactConfirmationModal'),
);
const FreeModal = lazy(() => import('./FreeModal'));
const InactiveUserFoundModal = lazy(
  () => import('./InactiveUserFoundModal/InactiveUserFoundModal'),
);
const IosPopupBlocker = lazy(() => import('./IosPopupBlocker'));
const SurveyModal = lazy(() => import('./SurveyModal'));
const UIBlockerModal = lazy(() => import('./UIBlockerModal'));
const FilterDrawer = lazy(() => import('components/Common/FilterDrawer'));
const ViewStudentListDrawer = lazy(
  () =>
    import(
      'components/Common/ViewEntityListDrawer/components/ViewStudentListDrawer'
    ),
);
const AlumniSurveysModal = lazy(() => import('./AlumniSurveysModal'));
const SurveyResultModal = lazy(
  () =>
    import(
      'modules/StudentCasefile/pages/SurveyResults/components/SurveyModal'
    ),
);
const WhoamiModal = lazy(() => import('./WhoamiModal'));

const SuperadminControlPanelModal = lazy(
  () => import('./SuperadminControlPanelModal'),
);

const CommentsModal = lazy(() => import('./CommentsModal'));

const EFillModal = lazy(() => import('modules/EFill'));

const ExternalContentDisclaimerModal = lazy(
  () => import('./ExternalContentDisclaimerModal'),
);

const MODALS = {
  // helper modals at top
  WHOAMI_MODAL: WhoamiModal,
  SUPERADMIN_CONTROL_PANEL_MODAL: SuperadminControlPanelModal,
  FREE_MODAL: FreeModal,
  CONFIRMATION_MODAL: ConfirmationModal,
  UI_BLOCKER_MODAL: UIBlockerModal,
  BULK_MESSAGE_MODAL: BulkMessageModal,
  BULK_PDF_DOWNLOAD_MODAL: BulkPDFDownloadModal,
  COURSE_PLAN_LISTING_EXPORT_MODAL: CoursePlanListingExportModal,
  IOS_POPUP_BLOCKER: IosPopupBlocker,
  SURVEY_COMMON_MODAL: SurveyModal,
  ALUMNI_CONTACT_INFO_MODAL: AlumniContactInfoModal,
  ALUMNI_CONTACT_INFO_DELETE_CONTACT_CONFIRMATION_MODAL:
    DeleteContactConfirmationModal,
  ALUMNI_CONTACT_INFO_CHOOSE_CONTACT_ENTITY_MODAL: ChooseContactInfoModal,
  INACTIVE_USER_FOUND_MODAL: InactiveUserFoundModal,
  FILTER_DRAWER: FilterDrawer,
  VIEW_STUDENT_LIST_DRAWER: ViewStudentListDrawer,
  ALUMNI_SURVEYS_MODAL: AlumniSurveysModal,
  SURVEY_RESULT_MODAL: SurveyResultModal,
  COMMENTS_MODAL: CommentsModal,
  EFILL_MODAL: EFillModal,
  EXTERNAL_CONTENT_DISCLAIMER_MODAL: ExternalContentDisclaimerModal,
  ...accountabilitySystemAnalyticsModals,
  ...accountabilitySystemSetupModals,
  ...alumniModals,
  ...alumniSurveyModals,
  ...appManagerModals,
  ...bulkStudentSelectModals,
  ...collegeAppConfigModals,
  ...commonModals,
  ...counselorDashboardModals,
  ...courseCatalogModals,
  ...coursePlannerListingModals,
  ...credentialWalletModals,
  ...coursePlannerModals,
  ...dashboardModals,
  ...dataIntegrationModals,
  ...digitalBadgesModals,
  ...districtSettingsModals,
  ...documentCenterModals,
  ...efillModals,
  ...elementaryCareersModals,
  ...experienceTrackingModals,
  ...fafsaReportingAndTrackingModals,
  ...finalListModals,
  ...guidedSetupModals,
  ...industryPartnerCRMModals,
  ...ippmModals,
  ...ipPlacementsModals,
  ...ipProgramExplorationModals,
  ...keyReadinessIndicatorsModals,
  ...indicatorVerificationModals,
  ...lessonLibraryModals,
  ...lifeSimulatorModals,
  ...meetingSchedulerModals,
  ...memberDashboardModals,
  ...memberEventsModals,
  ...memberManagementModals,
  ...mentorVideosModals,
  ...opportunitiesModals,
  ...orgMentorSetupModals,
  ...personalizedPlansModals,
  ...profileManagementModals,
  ...publicCourseCatalogModals,
  ...publicEventSchedulerModals,
  ...reportCenterModals,
  ...rosterAndTagManagementModals,
  ...staffAccountManagementModals,
  ...schoolProfileModals,
  ...schoolSearchModals,
  ...setAsGoalModals,
  ...staffDashboardModals,
  ...staffPersonalizedPlansModals,
  ...studentCasefileModals,
  ...studentDemoAccountModals,
  ...studentPlanListingModals,
  ...studentProfileModals,
  ...recordCenterModals,
  ...wouldYouRatherModals,
  ...testScoresModals,
  ...accountSettingsModals,
  ...awardLetterVerificationModals,
  ...elementaryStudentCasefileModals,
  ...elementaryCheckinsModals,
  ...surveyBankModals,
  ...studentGoalsModals,
  ...assessmentsModals,
  ...surveyModals,
  ...surveyAnalyticsModals,
  ...appManagerModalsV2,
  ...K12EventSchedulerV2Modals,
  ...surveyDetailsModals,
  ...uploaderModals,
  ...seniorSurveyModals,
  ...cteProgramsDashboard,
  ...featurePaywallModals,
  ...studentMeetingSchedulerModals,
  ...opportunityManagementModals,
};

export default MODALS;
